import React, { memo, useEffect, useRef, useState } from 'react';
import { HiMenuAlt2 } from 'react-icons/hi';
import { IoIosArrowDown } from 'react-icons/io';
import ActionLogo from '../../components/shared/logo/ActionLogo';
import HeaderMenu from './HeaderMenu';

function Index({ userData, setShowSidebar }) {
  const menuRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  return (
    <header className="header" ref={menuRef}>
      <div className="flex shadow-md bg-white flex-grow items-center p-4 justify-between xl:justify-end">
        <HeaderLogo setShowSidebar={setShowSidebar} />
        <div className="relative">
          <Account userData={userData} setShowDropdown={setShowDropdown} showDropdown={showDropdown} />
          {showDropdown && <HeaderMenu />}
        </div>
      </div>
    </header>
  );
}

const Account = ({ setShowDropdown, userData, showDropdown }) => (
  <button className="flex items-center gap-4 cursor-pointer" onClick={() => setShowDropdown((prev) => !prev)}>
    <div className="text-right hidden sm:block">
      <div className="block text-sm font-medium text-bg5">
        {userData?.lastName} {userData?.firstName}
      </div>
      <div className="block text-xs text-bg3">
        {userData?.roles.some((role) => role === 'ADMIN') ? 'Адміністратор' : 'Майстер'}
      </div>
    </div>
    <div className="h-10 w-10 rounded-3xl">
      <img src={userData?.picture || require('../../assets/avatar.jpg')} alt="profile" />
    </div>
    <IoIosArrowDown className={`hidden text-bg3 sm:block ${showDropdown && 'rotate-180'} duration-300`} />
  </button>
);

const HeaderLogo = ({ setShowSidebar }) => (
  <div className="flex xl:hidden">
    <button
      onClick={() => setShowSidebar(true)}
      className="flex items-center p-2 mr-2 rounded-xl hover:bg-gray-100 duration-300"
    >
      <HiMenuAlt2 size={24} className="text-bg3" />
    </button>
    <ActionLogo isDark={true} />
  </div>
);

export default memo(Index);
